import * as T from '@/types'

export function formatUrl (url: T.Url) {
    const { host, pathname } = new URL(url)
    const path = pathname.charAt(pathname.length - 1) === '/' ? pathname.substring(0, pathname.length - 2) : pathname
    return `${host}${path}`
}
